export default {
  tabs: {
    online_shop: 'Tienda en línea',
    reservations: 'Reservaciones',
    storefront: 'Tienda física',
  },
};
